"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.barredLUnicodeChart = {
    l: "ł",
    L: "Ł"
};
exports.barredLUnicode = function (name) { return exports.barredLUnicodeChart[name]; };
//# sourceMappingURL=barred-letter.js.map